<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div class="md-layout">
        <div class="md-layout-item md-size-30 md-small-size-100">
          <div class="picture-container">
            <div class="picture">
              <div v-if="!image">
                <img :src="avatar" class="picture-src" title="" />
              </div>
              <div v-else>
                <img :src="image" />
              </div>
              <input required type="file" :name="logo" @change="onLogoChange" />
            </div>
            <h6 class="description">Choose Logo</h6>
          </div>
        </div>
        <div class="md-layout-item md-size-70 mt-4 md-small-size-100">
          <ValidationProvider
            name="name"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>account_balance</md-icon>
              <label>University Name</label>
              <md-input v-model="name" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
          <ValidationProvider
            name="address"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>add_location</md-icon>
              <label>Address</label>
              <md-input v-model="address" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100">
          <ValidationProvider
            name="type"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>business</md-icon>
              <label>Type</label>
              <md-select v-model="type" name="type">
                <md-option value="">Select Type</md-option>
                <md-option value="2">Private</md-option>
                <md-option value="1">State</md-option>
              </md-select>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100">
          <ValidationProvider
            name="city"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>add_location</md-icon>
              <label>City</label>
              <md-select v-model="city" name="city">
                <md-option value="">Select City</md-option>
                <md-option
                  v-for="c in cities"
                  v-bind:key="c.id"
                  :value="c.id"
                  >{{ c.name }}</md-option
                >
              </md-select>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100">
          <ValidationProvider
            name="rank"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>analytics</md-icon>
              <label>Rank</label>
              <md-input v-model="rank" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100">
          <ValidationProvider
            name="website"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>book_online</md-icon>
              <label>Website</label>
              <md-input v-model="website" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100">
          <ValidationProvider
            name="main_photo"
            rules="required"
            v-slot="{ passed, failed }"
          >
            <md-field
              :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
            >
              <label>Main photo</label>
              <md-file
                v-model="main_photo"
                name="main_photo"
                @change="onMainPhotoChange"
              />

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100">
          <ValidationProvider
            name="order"
            rules="numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>account_balance</md-icon>
              <label>Order</label>
              <md-input v-model="order" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider name="about" v-slot="{ passed, failed }">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>article</md-icon>
              <label>About</label>
              <md-input v-model="about" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider name="history" v-slot="{ passed, failed }">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>assignment</md-icon>
              <label>History</label>
              <md-input v-model="history" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider name="our_mission" v-slot="{ passed, failed }">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>beenhere</md-icon>
              <label>Our mission</label>
              <md-input v-model="our_mission" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <ValidationProvider name="values" v-slot="{ passed, failed }">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>account_balance</md-icon>
              <label>Values</label>
              <md-input v-model="values" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100">
          <ValidationProvider name="campus_life" v-slot="{ passed, failed }">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>account_balance</md-icon>
              <label>Campus Life</label>
              <md-input v-model="campus_life" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100">
          <ValidationProvider
            name="year_of_foundation"
            v-slot="{ passed, failed }"
          >
            <md-datepicker
              :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              v-model="year_of_foundation"
              md-immediately
            >
              <label>Years of foundation</label>
              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-datepicker>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100"></div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <ValidationProvider
            name="campus_number"
            rules="numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>leaderboard</md-icon>
              <label>Campus Number</label>
              <md-input v-model="campus_number" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <ValidationProvider
            name="faculties_number"
            rules="numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>leaderboard</md-icon>
              <label>Faculties Number</label>
              <md-input v-model="faculties_number" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <ValidationProvider
            name="associate_programs_number"
            rules="numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>leaderboard</md-icon>
              <label>Associate Programs Number</label>
              <md-input v-model="associate_programs_number" type="text">
              </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <ValidationProvider
            name="bachelor_programs_number"
            rules="numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>leaderboard</md-icon>
              <label>Bachelor Programs Number</label>
              <md-input v-model="bachelor_programs_number" type="text">
              </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <ValidationProvider
            name="master_programs_number"
            rules="numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>leaderboard</md-icon>
              <label>Master Programs Number</label>
              <md-input v-model="master_programs_number" type="text">
              </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <ValidationProvider
            name="phd_programs_number"
            rules="numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>leaderboard</md-icon>
              <label>Phd programs number</label>
              <md-input v-model="phd_programs_number" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <ValidationProvider
            name="students_number"
            rules="numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>leaderboard</md-icon>
              <label>Students Number</label>
              <md-input v-model="students_number" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <ValidationProvider
            name="alumni_number"
            rules="numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>leaderboard</md-icon>
              <label>Alumni Number</label>
              <md-input v-model="alumni_number" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <ValidationProvider
            name="acceptance_rate_percent"
            rules="numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>leaderboard</md-icon>
              <label>Acceptance Rate Percent</label>
              <md-input v-model="acceptance_rate_percent" type="text">
              </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <ValidationProvider
            name="partners_number"
            rules="numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>leaderboard</md-icon>
              <label>Partners Number</label>
              <md-input v-model="partners_number" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <ValidationProvider
            name="academic_employee_number"
            rules="numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>leaderboard</md-icon>
              <label>Academic Employee Number</label>
              <md-input v-model="academic_employee_number" type="text">
              </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <ValidationProvider
            name="research_centers_number"
            rules="numeric"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>leaderboard</md-icon>
              <label>Research Centers Number</label>
              <md-input v-model="research_centers_number" type="text">
              </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <ValidationProvider name="kdv" v-slot="{ passed, failed }">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>%</md-icon>
              <label>KDV</label>
              <md-input v-model="kdv" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <ValidationProvider name="gv" v-slot="{ passed, failed }">
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>%</md-icon>
              <label>GV</label>
              <md-input v-model="gv" type="text"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <md-checkbox v-model="contract">Contract?</md-checkbox>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100" style="margin-top: 20px">
          <label>About</label>
          <ckeditor :editor="editor" v-model="about" :config="editorConfig"></ckeditor>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100" style="margin-top: 20px">
          <label>History</label>
          <ckeditor :editor="editor" v-model="history" :config="editorConfig"></ckeditor>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100" style="margin-top: 20px">
          <label>Our Mission</label>
          <ckeditor :editor="editor" v-model="our_mission" :config="editorConfig"></ckeditor>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100" style="margin-top: 20px">
          <label>Values</label>
          <ckeditor :editor="editor" v-model="values" :config="editorConfig"></ckeditor>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100" style="margin-top: 20px">
          <label>Campus Life</label>
          <ckeditor :editor="editor" v-model="campus_life" :config="editorConfig"></ckeditor>
        </div>

        <div class="md-layout-item md-size-75 md-small-size-0"></div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

extend("required", required);
extend("email", email);

export default {
  components: {
    SlideYDownTransition,
    ckeditor: CKEditor.component
  },
  props: {
    avatar: {
      type: String,
      default: "/img/image_placeholder.jpg"
    }
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},

      cities: [],
      image: null,
      name: null,
      address: null,
      rank: null,
      website: null,
      type: null,
      city: null,
      logo: null,
      main_photo: null,
      main_photo_image: null,
      order: null,
      about: null,
      history: null,
      our_mission: null,
      values: null,
      campus_life: null,
      year_of_foundation: null,
      campus_number: null,
      faculties_number: null,
      associate_programs_number: null,
      bachelor_programs_number: null,
      master_programs_number: null,
      phd_programs_number: null,
      students_number: null,
      alumni_number: null,
      acceptance_rate_percent: null,
      partners_number: null,
      academic_employee_number: null,
      research_centers_number: null,
      kdv: null,
      gv: null,
      contract: false
    };
  },
  methods: {
    handlePreview(file) {
      this.model.imageUrl = URL.createObjectURL(file.raw);
    },
    onMainPhotoChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.main_photo_image = files[0];
    },
    onLogoChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.logo = files[0];
      this.createImage(files[0]);
    },
    createImage(file) {
      var reader = new FileReader();
      var vm = this;

      reader.onload = e => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    validate() {
      return this.$refs.form.validate().then(res => {
        if (!res) {
          return;
        }
        this.$emit("on-validated", res);
        return res;
      });
    }
  },
  mounted() {
    this.$store
      .getCities()
      .then(response => {
        this.cities = response.data.results;
      })
      .catch(error => {
        this.$notify({
          message: error.message,
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
      });
  }
};
</script>
<style></style>
